// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__r_B9a"};